import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

const UserFormModal = ({ user, onClose, onSubmit }) => {

    const isEdit = Boolean(user);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phone, setPhone] = useState("");
    const [role, setRole] = useState("user");

    useEffect(() => {
        document.body.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    useEffect(() => {
        if (user) {
            setFirstName(user.firstName || "");
            setLastName(user.lastName || "");
            setPhone(user.phone || "");
            setRole(user.role || "user");
        }
    }, [user]);


    // تبدیل اعداد فارسی و عربی به انگلیسی
    const convertToEnglishNumbers = (value) => {
        const persian = "۰۱۲۳۴۵۶۷۸۹";
        const arabic = "٠١٢٣٤٥٦٧٨٩";

        return value
            .replace(/[۰-۹]/g, d => persian.indexOf(d))
            .replace(/[٠-٩]/g, d => arabic.indexOf(d));
    };



    // فقط اعداد برای موبایل
    const handlePhoneChange = (e) => {

        let value = convertToEnglishNumbers(e.target.value);

        value = value.replace(/[^0-9]/g, "");

        if (value.length <= 11) {
            setPhone(value);
        }
    };



    // فقط حروف فارسی
    const handlePersianName = (setter) => (e) => {

        let value = e.target.value;

        value = value.replace(/[^آ-ی\s]/g, "");

        setter(value);
    };

    const validatePhone = (phone) => {

        if (!/^09\d{9}$/.test(phone)) {
            toast.error("شماره موبایل نامعتبر است", {
                className: "z-[10001]"
            });
            return false;
        }

        return true;
    };


    const validateName = (name, field) => {

        if (!/^[آ-ی\s]+$/.test(name)) {
            toast.error(`${field} فقط باید شامل حروف فارسی باشد`, {
                className: "z-[10001]"
            });
            return false;
        }

        return true;
    };

    const handleSubmit = (e) => {

        e.preventDefault();

        if (!validateName(firstName, "نام")) return;
        if (!validateName(lastName, "نام خانوادگی")) return;
        if (!validatePhone(phone)) return;

        const payload = {
            firstName,
            lastName,
            phone,
            role
        };

        if (isEdit) {
            onSubmit(user._id, payload);
        } else {
            onSubmit(payload);
        }

        onClose();
    };



    return (
        <div className="fixed top-0 left-0 w-screen h-screen !mt-0 inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-[1000]">

            <div className="bg-white w-full max-w-md rounded-xl shadow-xl p-6">

                <h2 className="text-lg font-semibold mb-4">
                    {isEdit ? "ویرایش کاربر" : "ساخت کاربر جدید"}
                </h2>

                <form onSubmit={handleSubmit} className="space-y-4">

                    <div>
                        <label className="text-sm text-gray-500">نام</label>
                        <input
                            type="text"
                            value={firstName}
                            onChange={handlePersianName(setFirstName)}
                            required
                            className="w-full border rounded-lg p-2 mt-1 text-sm focus:ring-2 focus:ring-purple-400 outline-none"
                        />
                    </div>

                    <div>
                        <label className="text-sm text-gray-500">نام خانوادگی</label>
                        <input
                            type="text"
                            value={lastName}
                            onChange={handlePersianName(setLastName)}
                            required
                            className="w-full border rounded-lg p-2 mt-1 text-sm focus:ring-2 focus:ring-purple-400 outline-none"
                        />
                    </div>

                    <div>
                        <label className="text-sm text-gray-500">شماره موبایل</label>
                        <input
                            type="tel"
                            value={phone}
                            onChange={handlePhoneChange}
                            inputMode="numeric"
                            placeholder="09xxxxxxxxx"
                            className="w-full border rounded-lg p-2 mt-1 text-sm focus:ring-2 focus:ring-purple-400 outline-none"
                        />
                    </div>

                    <div>
                        <label className="text-sm text-gray-500">نقش</label>
                        <select
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                            className="w-full border rounded-lg p-2 mt-1 text-sm focus:ring-2 focus:ring-purple-400 outline-none"
                        >
                            <option value="user">کاربر</option>
                            <option value="admin">ادمین</option>
                            <option value="staff">کارکن</option>
                        </select>
                    </div>

                    <div className="flex justify-between pt-3">

                        <button
                            type="button"
                            className="px-4 py-2 rounded-lg bg-gray-100 text-sm hover:bg-gray-200"
                            onClick={onClose}
                        >
                            انصراف
                        </button>

                        <button
                            type="submit"
                            className="px-4 py-2 rounded-lg bg-purple-600 text-white text-sm hover:bg-purple-700"
                        >
                            {isEdit ? "ذخیره تغییرات" : "ساخت کاربر"}
                        </button>

                    </div>

                </form>

            </div>

        </div>
    );
};

export default UserFormModal;